import React from "react";
import swarmHeroBg from "../../assets/RPA/swarm-hero-bg.png";
import supplyChainCaseStudy from "../../assets/RPA/supply-chain-case-study.png";
import { Footer } from "../Footer";
import { Header } from "../header/Header";
import { useNavigate } from "react-router-dom";

const SwarmAI = () => {
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 w-screen h-screen flex flex-col overflow-hidden">
      <div>
        <Header />
      </div>
      <div className=" w-full h-full tracking-wider overflow-y-auto overflow-x-hidden ">
        <div className="bg-white relative w-screen overflow-x-hidden font-sans">
          {/* Hero Section */}
          <section className="relative min-h-screen flex items-center justify-center pt-16 pb-20 px-6 overflow-hidden bg-[radial-gradient(ellipse_123.20%_171.22%_at_100.00%_0.00%,_rgba(27,_94,_32,_0.20)_0%,_#F5FCED_50%,_#F5FCED_100%)]">
            <div className="max-w-[1536px] w-full grid grid-cols-1 largeScreen:grid-cols-2 gap-12 relative z-10 place-items-center">
              <div className="flex flex-col gap-8 justify-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00450d]/10 backdrop-blur-md rounded-full w-fit">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M4.5 17.25C3.875 17.25 3.34375 17.0312 2.90625 16.5938C2.46875 16.1562 2.25 15.625 2.25 15C2.25 14.375 2.46875 13.8438 2.90625 13.4062C3.34375 12.9688 3.875 12.75 4.5 12.75C4.675 12.75 4.8375 12.7687 4.9875 12.8062C5.1375 12.8438 5.28125 12.8938 5.41875 12.9563L6.4875 11.625C6.1375 11.2375 5.89375 10.8 5.75625 10.3125C5.61875 9.825 5.5875 9.3375 5.6625 8.85L4.14375 8.34375C3.93125 8.65625 3.6625 8.90625 3.3375 9.09375C3.0125 9.28125 2.65 9.375 2.25 9.375C1.625 9.375 1.09375 9.15625 0.65625 8.71875C0.21875 8.28125 0 7.75 0 7.125C0 6.5 0.21875 5.96875 0.65625 5.53125C1.09375 5.09375 1.625 4.875 2.25 4.875C2.875 4.875 3.40625 5.09375 3.84375 5.53125C4.28125 5.96875 4.5 6.5 4.5 7.125C4.5 7.15 4.5 7.175 4.5 7.2C4.5 7.225 4.5 7.25 4.5 7.275L6.01875 7.8C6.26875 7.35 6.60313 6.96875 7.02187 6.65625C7.44062 6.34375 7.9125 6.14375 8.4375 6.05625V4.425C7.95 4.2875 7.54688 4.02187 7.22813 3.62812C6.90938 3.23438 6.75 2.775 6.75 2.25C6.75 1.625 6.96875 1.09375 7.40625 0.65625C7.84375 0.21875 8.375 0 9 0C9.625 0 10.1562 0.21875 10.5938 0.65625C11.0312 1.09375 11.25 1.625 11.25 2.25C11.25 2.775 11.0875 3.23438 10.7625 3.62812C10.4375 4.02187 10.0375 4.2875 9.5625 4.425V6.05625C10.0875 6.14375 10.5594 6.34375 10.9781 6.65625C11.3969 6.96875 11.7312 7.35 11.9812 7.8L13.5 7.275C13.5 7.25 13.5 7.225 13.5 7.2C13.5 7.175 13.5 7.15 13.5 7.125C13.5 6.5 13.7188 5.96875 14.1562 5.53125C14.5938 5.09375 15.125 4.875 15.75 4.875C16.375 4.875 16.9062 5.09375 17.3438 5.53125C17.7812 5.96875 18 6.5 18 7.125C18 7.75 17.7812 8.28125 17.3438 8.71875C16.9062 9.15625 16.375 9.375 15.75 9.375C15.35 9.375 14.9844 9.28125 14.6531 9.09375C14.3219 8.90625 14.0562 8.65625 13.8562 8.34375L12.3375 8.85C12.4125 9.3375 12.3812 9.82188 12.2437 10.3031C12.1062 10.7844 11.8625 11.225 11.5125 11.625L12.5813 12.9375C12.7188 12.875 12.8625 12.8281 13.0125 12.7969C13.1625 12.7656 13.325 12.75 13.5 12.75C14.125 12.75 14.6562 12.9688 15.0938 13.4062C15.5312 13.8438 15.75 14.375 15.75 15C15.75 15.625 15.5312 16.1562 15.0938 16.5938C14.6562 17.0312 14.125 17.25 13.5 17.25C12.875 17.25 12.3438 17.0312 11.9062 16.5938C11.4688 16.1562 11.25 15.625 11.25 15C11.25 14.75 11.2906 14.5094 11.3719 14.2781C11.4531 14.0469 11.5625 13.8375 11.7 13.65L10.6313 12.3188C10.1188 12.6063 9.57188 12.75 8.99063 12.75C8.40938 12.75 7.8625 12.6063 7.35 12.3188L6.3 13.65C6.4375 13.8375 6.54688 14.0469 6.62813 14.2781C6.70938 14.5094 6.75 14.75 6.75 15C6.75 15.625 6.53125 16.1562 6.09375 16.5938C5.65625 17.0312 5.125 17.25 4.5 17.25ZM2.25 7.875C2.4625 7.875 2.64062 7.80313 2.78437 7.65938C2.92812 7.51562 3 7.3375 3 7.125C3 6.9125 2.92812 6.73438 2.78437 6.59062C2.64062 6.44687 2.4625 6.375 2.25 6.375C2.0375 6.375 1.85938 6.44687 1.71563 6.59062C1.57188 6.73438 1.5 6.9125 1.5 7.125C1.5 7.3375 1.57188 7.51562 1.71563 7.65938C1.85938 7.80313 2.0375 7.875 2.25 7.875ZM4.5 15.75C4.7125 15.75 4.89062 15.6781 5.03438 15.5344C5.17813 15.3906 5.25 15.2125 5.25 15C5.25 14.7875 5.17813 14.6094 5.03438 14.4656C4.89062 14.3219 4.7125 14.25 4.5 14.25C4.2875 14.25 4.10938 14.3219 3.96563 14.4656C3.82188 14.6094 3.75 14.7875 3.75 15C3.75 15.2125 3.82188 15.3906 3.96563 15.5344C4.10938 15.6781 4.2875 15.75 4.5 15.75ZM9 3C9.2125 3 9.39062 2.92812 9.53438 2.78437C9.67813 2.64062 9.75 2.4625 9.75 2.25C9.75 2.0375 9.67813 1.85938 9.53438 1.71563C9.39062 1.57188 9.2125 1.5 9 1.5C8.7875 1.5 8.60938 1.57188 8.46562 1.71563C8.32187 1.85938 8.25 2.0375 8.25 2.25C8.25 2.4625 8.32187 2.64062 8.46562 2.78437C8.60938 2.92812 8.7875 3 9 3ZM9 11.25C9.525 11.25 9.96875 11.0688 10.3313 10.7063C10.6938 10.3438 10.875 9.9 10.875 9.375C10.875 8.85 10.6938 8.40625 10.3313 8.04375C9.96875 7.68125 9.525 7.5 9 7.5C8.475 7.5 8.03125 7.68125 7.66875 8.04375C7.30625 8.40625 7.125 8.85 7.125 9.375C7.125 9.9 7.30625 10.3438 7.66875 10.7063C8.03125 11.0688 8.475 11.25 9 11.25ZM13.5 15.75C13.7125 15.75 13.8906 15.6781 14.0344 15.5344C14.1781 15.3906 14.25 15.2125 14.25 15C14.25 14.7875 14.1781 14.6094 14.0344 14.4656C13.8906 14.3219 13.7125 14.25 13.5 14.25C13.2875 14.25 13.1094 14.3219 12.9656 14.4656C12.8219 14.6094 12.75 14.7875 12.75 15C12.75 15.2125 12.8219 15.3906 12.9656 15.5344C13.1094 15.6781 13.2875 15.75 13.5 15.75ZM15.75 7.875C15.9625 7.875 16.1406 7.80313 16.2844 7.65938C16.4281 7.51562 16.5 7.3375 16.5 7.125C16.5 6.9125 16.4281 6.73438 16.2844 6.59062C16.1406 6.44687 15.9625 6.375 15.75 6.375C15.5375 6.375 15.3594 6.44687 15.2156 6.59062C15.0719 6.73438 15 6.9125 15 7.125C15 7.3375 15.0719 7.51562 15.2156 7.65938C15.3594 7.80313 15.5375 7.875 15.75 7.875Z"
                      fill="#00450D"
                    />
                  </svg>
                  <span className="text-[#00450d] text-sm font-semibold tracking-wide uppercase">
                    The Future of Collective Intelligence
                  </span>
                </div>

                <h1 className="text-4xl ipadMax:text-6xl largeScreen:text-[72px] font-extrabold text-[#171d14] leading-tight tracking-tight">
                  Multi-Agent Swarms <br />
                  <span className="text-[#00450d]">Orchestrating</span> <br />
                  Collective <br />
                  Intelligence
                </h1>

                <p className="text-xl text-[#41493e] max-w-[580px] leading-relaxed">
                  Deploy specialized AI units that don't just work—they
                  collaborate. Our swarm engine synchronizes hundreds of
                  autonomous agents to solve complex cross-departmental data
                  challenges in real-time.
                </p>

                {/* <div className="flex flex-wrap gap-4 mt-4">
                  <button className="bg-[#00450d] text-white px-10 py-5 rounded-full font-semibold text-lg hover:bg-[#005c12] transition-colors shadow-lg shadow-[#00450d]/20">
                    Explore Architecture
                  </button>
                </div> */}
              </div>

              <div className="relative group">
                <div className="relative rounded-[32px] overflow-hidden shadow-2xl border border-white/40 bg-white/70 backdrop-blur-sm">
                  <img
                    src={swarmHeroBg}
                    alt="Architecture Visualization"
                    className="w-full h-full object-cover mix-blend-multiply opacity-90"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#00450d]/40 to-transparent"></div>

                  {/* Floating Data Chips */}
                  <div className="absolute top-10 left-10 bg-white/80 backdrop-blur-md px-5 py-4 rounded-3xl border border-white/50 shadow-xl flex items-center gap-3 animate-pulse">
                    <div className="w-3 h-3 bg-[#f6e550] rounded-full shadow-[0_0_10px_#f6e550]"></div>
                    <span className="text-[#00450d] font-bold">
                      Node 082: Active
                    </span>
                  </div>

                  <div className="absolute bottom-10 right-10 bg-white/80 backdrop-blur-md px-5 py-4 rounded-3xl border border-white/50 shadow-xl flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16ZM2 2V16V2Z"
                        fill="#00450D"
                      />
                    </svg>
                    <span className="text-[#00450d] font-bold">
                      Processing Consensus
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Architecture Section */}
          <section className="bg-[#eff6e7] py-24 px-6 overflow-hidden">
            <div className="max-w-[1536px] mx-auto text-center mb-20 flex flex-col items-center">
              <h2 className="text-4xl font-bold text-[#171d14] mb-6 tracking-tight">
                Built for Autonomy
              </h2>
              <p className="text-lg text-[#41493e] max-w-[720px] leading-relaxed">
                A modular architecture that separates decision-making from
                execution, allowing for unparalleled precision and speed.
              </p>
            </div>

            <div className="max-w-[1536px] mx-auto grid grid-cols-2 ipadMin:grid-cols-1 mobile:grid-cols-1 md:grid-cols-2 gap-8">
              {/* Card 1: Orchestrator */}
              <div className="bg-white/70 backdrop-blur-md border border-white rounded-[32px] p-12 shadow-sm flex flex-col gap-8 relative overflow-hidden group hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-[#00450d] rounded-2xl flex items-center justify-center text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M3.75 25V19.625C2.5625 18.5417 1.64062 17.276 0.984375 15.8281C0.328125 14.3802 0 12.8542 0 11.25C0 8.125 1.09375 5.46875 3.28125 3.28125C5.46875 1.09375 8.125 0 11.25 0C13.8542 0 16.1615 0.765625 18.1719 2.29688C20.1823 3.82812 21.4896 5.82292 22.0938 8.28125L23.7188 14.6875C23.8229 15.0833 23.75 15.4427 23.5 15.7656C23.25 16.0885 22.9167 16.25 22.5 16.25H20V20C20 20.6875 19.7552 21.276 19.2656 21.7656C18.776 22.2552 18.1875 22.5 17.5 22.5H15V25H12.5V20H17.5V13.75H20.875L19.6875 8.90625C19.2083 7.01042 18.1875 5.46875 16.625 4.28125C15.0625 3.09375 13.2708 2.5 11.25 2.5C8.83333 2.5 6.77083 3.34375 5.0625 5.03125C3.35417 6.71875 2.5 8.77083 2.5 11.1875C2.5 12.4375 2.75521 13.625 3.26562 14.75C3.77604 15.875 4.5 16.875 5.4375 17.75L6.25 18.5V25H3.75ZM10 16.25H12.5L12.6875 14.6875C12.8542 14.625 13.0052 14.5521 13.1406 14.4688C13.276 14.3854 13.3958 14.2917 13.5 14.1875L14.9375 14.8125L16.1875 12.6875L14.9375 11.75C14.9792 11.5833 15 11.4167 15 11.25C15 11.0833 14.9792 10.9167 14.9375 10.75L16.1875 9.8125L14.9375 7.6875L13.5 8.3125C13.3958 8.20833 13.276 8.11458 13.1406 8.03125C13.0052 7.94792 12.8542 7.875 12.6875 7.8125L12.5 6.25H10L9.8125 7.8125C9.64583 7.875 9.49479 7.94792 9.35938 8.03125C9.22396 8.11458 9.10417 8.20833 9 8.3125L7.5625 7.6875L6.3125 9.8125L7.5625 10.75C7.52083 10.9167 7.5 11.0833 7.5 11.25C7.5 11.4167 7.52083 11.5833 7.5625 11.75L6.3125 12.6875L7.5625 14.8125L9 14.1875C9.10417 14.2917 9.22396 14.3854 9.35938 14.4688C9.49479 14.5521 9.64583 14.625 9.8125 14.6875L10 16.25ZM11.25 13.125C10.7292 13.125 10.2865 12.9427 9.92188 12.5781C9.55729 12.2135 9.375 11.7708 9.375 11.25C9.375 10.7292 9.55729 10.2865 9.92188 9.92188C10.2865 9.55729 10.7292 9.375 11.25 9.375C11.7708 9.375 12.2135 9.55729 12.5781 9.92188C12.9427 10.2865 13.125 10.7292 13.125 11.25C13.125 11.7708 12.9427 12.2135 12.5781 12.5781C12.2135 12.9427 11.7708 13.125 11.25 13.125Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-[#171d14] mb-4">
                    The Orchestrator
                  </h3>
                  <p className="text-lg text-[#41493e] leading-relaxed mb-8">
                    The central intelligence layer that interprets high-level
                    business goals, decomposes them into manageable tasks, and
                    assigns them to specialized nodes.
                  </p>
                  <ul className="space-y-4">
                    {[
                      "Semantic Task Decomposition",
                      "Global State Management",
                      "Conflict Resolution Protocol",
                    ].map((item, i) => (
                      <li
                        key={i}
                        className="flex items-center gap-3 text-[#00450d] font-medium"
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Card 2: Swarm Nodes */}
              <div className="bg-[#00450d] rounded-[32px] p-12 shadow-2xl flex flex-col gap-8 relative overflow-hidden group">
                <div className="w-16 h-16 bg-[#f6e550] rounded-2xl flex items-center justify-center text-[#00450d]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                  >
                    <path
                      d="M7.5 15V7.5H15V15H7.5ZM10 12.5H12.5V10H10V12.5ZM7.5 22.5V20H5C4.3125 20 3.72396 19.7552 3.23438 19.2656C2.74479 18.776 2.5 18.1875 2.5 17.5V15H0V12.5H2.5V10H0V7.5H2.5V5C2.5 4.3125 2.74479 3.72396 3.23438 3.23438C3.72396 2.74479 4.3125 2.5 5 2.5H7.5V0H10V2.5H12.5V0H15V2.5H17.5C18.1875 2.5 18.776 2.74479 19.2656 3.23438C19.7552 3.72396 20 4.3125 20 5V7.5H22.5V10H20V12.5H22.5V15H20V17.5C20 18.1875 19.7552 18.776 19.2656 19.2656C18.776 19.7552 18.1875 20 17.5 20H15V22.5H12.5V20H10V22.5H7.5ZM17.5 17.5V5H5V17.5H17.5Z"
                      fill="#1F1C00"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-white mb-4">
                    Swarm Nodes
                  </h3>
                  <p className="text-lg text-[rgba(172,244,164,0.8)] leading-relaxed mb-8">
                    Highly specialized, lightweight execution units focused on
                    specific domains—be it data extraction, risk analysis, or
                    creative synthesis.
                  </p>
                  <ul className="space-y-4">
                    {[
                      "Localized Decision Power",
                      "Instant Peer Communication",
                      "Sandbox Execution Environment",
                    ].map((item, i) => (
                      <li
                        key={i}
                        className="flex items-center gap-3 text-[#f6e550] font-medium"
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="absolute top-[-80px] right-[-80px] w-64 h-64 bg-[#f6e550]/10 blur-[40px] rounded-full group-hover:bg-[#f6e550]/20 transition-all"></div>
              </div>
            </div>
          </section>

          {/* Capabilities Section */}
          <section className="py-24 px-6">
            <div className="max-w-[1536px] mx-auto flex flex-row justify-between items-end gap-8 mb-20">
              <div className="flex flex-col gap-4">
                <span className="text-[#00450d] text-sm font-bold tracking-[2px] uppercase">
                  Capabilities
                </span>
                <h2 className="text-4xl ipadMax:text-5xl font-extrabold text-[#171d14] tracking-tight">
                  Intelligence that adapts <br /> to your growth.
                </h2>
              </div>
            </div>

            <div className="max-w-[1536px] mx-auto grid mobile:grid-cols-1 grid-cols-3 ipadMin:gap-5 ipadMax:gap- gap-12">
              {[
                {
                  title: "Real-time Task Allocation",
                  desc: "Agents don't wait for instructions. They bid for tasks based on their current load and expertise, ensuring optimal throughput at every second.",
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="18"
                      viewBox="0 0 20 18"
                      fill="none"
                    >
                      <path
                        d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V9H2V16H11V18H2ZM6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12V5H6V12H15V14H6ZM10 10C9.45 10 8.97917 9.80417 8.5875 9.4125C8.19583 9.02083 8 8.55 8 8V2C8 1.45 8.19583 0.979167 8.5875 0.5875C8.97917 0.195833 9.45 0 10 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V8C20 8.55 19.8042 9.02083 19.4125 9.4125C19.0208 9.80417 18.55 10 18 10H10ZM10 8H18V4H10V8Z"
                        fill="#1B5E20"
                      />
                    </svg>
                  ),
                },
                {
                  title: "Consensus Protocols",
                  desc: "No single point of failure. Agents cross-verify results using cryptographic proofs, ensuring that every swarm decision is high-trust and accurate.",
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="20"
                      viewBox="0 0 16 20"
                      fill="none"
                    >
                      <path
                        d="M6.95 13.55L12.6 7.9L11.175 6.475L6.95 10.7L4.85 8.6L3.425 10.025L6.95 13.55ZM8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V9.1C16 11.6333 15.2458 13.9375 13.7375 16.0125C12.2292 18.0875 10.3167 19.4167 8 20ZM8 17.9C9.73333 17.35 11.1667 16.25 12.3 14.6C13.4333 12.95 14 11.1167 14 9.1V4.375L8 2.125L2 4.375V9.1C2 11.1167 2.56667 12.95 3.7 14.6C4.83333 16.25 6.26667 17.35 8 17.9Z"
                        fill="#1B5E20"
                      />
                    </svg>
                  ),
                },
                {
                  title: "Dynamic Scalability",
                  desc: "From 10 to 10,000 agents in milliseconds. The swarm expands and contracts automatically based on workload complexity and priority.",
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="12"
                      viewBox="0 0 20 12"
                      fill="none"
                    >
                      <path
                        d="M1.4 12L0 10.6L7.4 3.15L11.4 7.15L16.6 2H14V0H20V6H18V3.4L11.4 10L7.4 6L1.4 12Z"
                        fill="#1B5E20"
                      />
                    </svg>
                  ),
                },
              ].map((cap, i) => (
                <div key={i} className="flex flex-col gap-6">
                  <div className="w-14 h-14 bg-[#1b5e20]/5 rounded-full flex items-center justify-center text-[#1b5e20]">
                    {cap.icon}
                  </div>
                  <h4 className="text-2xl font-bold text-[#171d14]">
                    {cap.title}
                  </h4>
                  <p className="text-[#41493e] leading-relaxed">{cap.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Case Study Section */}
          <section className="bg-[#00450d] py-24 px-6 overflow-hidden">
            <div className="max-w-[1536px] mx-auto bg-white/5 backdrop-blur-md rounded-[48px] p-8 md:p-20 border border-white/10 relative">
              <div className="grid grid-cols-1 largeScreen:grid-cols-2 gap-20 items-center">
                <div className="flex flex-col gap-10">
                  <div className="text-[#f6e550] font-bold tracking-[2px] uppercase text-sm">
                    CASE STUDY: SUPPLY CHAIN RECONCILIATION
                  </div>
                  <h2 className="text-4xl ipadMax:text-5xl font-extrabold text-white leading-tight">
                    Handling 1M+ SKU <br /> discrepancies in <br /> under 4
                    minutes.
                  </h2>

                  <div className="flex flex-col gap-8">
                    {[
                      {
                        id: "01",
                        title: "Ingestion & Mapping",
                        desc: "Swarm agents instantly ingest global ERP data, mapping incompatible schemas to a unified graph.",
                      },
                      {
                        id: "02",
                        title: "Anomaly Detection",
                        desc: "Parallel agents scan for pricing mismatches and logistics delays, flagging priorities instantly.",
                      },
                      {
                        id: "03",
                        title: "Autonomous Resolution",
                        desc: "Agents communicate with supplier APIs to reconcile orders without human intervention.",
                      },
                    ].map((step, i) => (
                      <div key={i} className="flex gap-6 items-start">
                        <span className="text-[#f6e550] text-2xl font-bold pt-1">
                          {step.id}
                        </span>
                        <div>
                          <h5 className="text-xl font-bold text-white mb-2">
                            {step.title}
                          </h5>
                          <p className="text-[rgba(172,244,164,0.6)]">
                            {step.desc}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="relative">
                  <div className="rounded-[32px] overflow-hidden border-4 border-white/10 shadow-2xl aspect-video relative group">
                    <img
                      src={supplyChainCaseStudy}
                      alt="Supply Chain Visualization"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
                    />
                    <div className="absolute inset-0 bg-[#00450d]/20 flex items-center justify-center">
                      <div className="w-20 h-20 bg-[#f6e550] rounded-full flex items-center justify-center shadow-2xl cursor-pointer hover:scale-110 transition-transform">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="21"
                          viewBox="0 0 17 21"
                          fill="none"
                        >
                          <path
                            d="M0 21V0L16.5 10.5L0 21ZM3 15.525L10.875 10.5L3 5.475V15.525Z"
                            fill="#1F1C00"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Floating Stat Card */}
                  <div className="absolute -bottom-10 -right-10 ipadMax:right-[-24px] bg-white/80 backdrop-blur-xl p-8 rounded-[32px] border border-white/20 shadow-2xl max-w-[280px]">
                    <div className="text-[#00450d] text-4xl font-extrabold mb-2 ">
                      99.2%
                    </div>
                    <p className="text-[#41493e] text-sm font-semibold leading-relaxed">
                      Accuracy improvement over manual audit.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-24 px-6 text-center">
            <div className="max-w-[896px] mx-auto flex flex-col items-center gap-10">
              <h2 className="text-5xl font-extrabold text-[#171d14] tracking-tight">
                Ready to release the swarm?
              </h2>
              <p className="text-xl text-[#41493e] leading-relaxed">
                Join the most innovative enterprises in building the next
                generation of autonomous infrastructure.
              </p>

              <div className="flex flex-wrap justify-center gap-4 mt-4">
                <button
                  onClick={() => navigate("/contact-us")}
                  className="bg-[#f6e550] text-[#1f1c00] px-12 py-5 rounded-full font-bold text-xl hover:bg-[#ffe500] transition-colors"
                >
                  Book a Workshop
                </button>
              </div>
            </div>
          </section>
        </div>
        <div id="footer">
          {" "}
          <Footer />
        </div>{" "}
      </div>
    </div>
  );
};

export default SwarmAI;
